import { t } from 'i18next'
import { useMemo } from 'react'
import { NO_DATA_PLACEHOLDER } from '../../../../constants/constants'
import { useWorkspaceDetails } from '../../../../hooks'
import { WorkspaceConfig } from '../../../../store/reducers/workspaceReducer'
import WorkspaceStatistic from './WorkspaceStatistic'
import WorkspaceStatisticsPanelContainer from './WorkspaceStatisticsPanelContainer'

const QualityReviewSmartFunctionStatisticsPanel = () => {
  const { selectedWorkspace } = useWorkspaceDetails({ preventFetch: true })

  const totalDocuments = useMemo(() => {
    const config = selectedWorkspace?.config as WorkspaceConfig | undefined
    const totalDocuments =
      config?.conformityChecksConfig?.documents?.length ?? 0
    return totalDocuments
  }, [selectedWorkspace])

  return (
    <WorkspaceStatisticsPanelContainer>
      <WorkspaceStatistic
        title={t(
          'workspaceDetailsPage.workspaceOverviewInfoPanel.qualityReviewStatistics.totalDocuments'
        )}
        value={totalDocuments || NO_DATA_PLACEHOLDER}
      />
    </WorkspaceStatisticsPanelContainer>
  )
}

export default QualityReviewSmartFunctionStatisticsPanel
